import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';
import { OrderCustomData } from 'types/embedded/orderCustomData';
import { OrderDispute } from 'types/embedded/orderDispute';
import { OrderStatus } from 'types/embedded/orderStatus';
import { getId } from 'utils';

export const orderAccept = async (id: string): Promise<AxiosResponse> => {
  return axios
    .post(`${Resources.Orders}/${id}/pilot_mode/accept`, {})
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const orderDecline = async (id: string): Promise<AxiosResponse> => {
  return axios
    .post(`${Resources.Orders}/${id}/pilot_mode/decline`, {})
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const sendOrderNotification = async (id: string): Promise<AxiosResponse> => {
  return axios
    .post(`order_notify/${getId(id)}`, {})
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const bulkResendOrderNotifications = async (ids: string[]): Promise<AxiosResponse> => {
  return axios
    .post('order_notify/bulk/resend', { ids: ids.map(Number) })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const createDispute = async (form: Partial<OrderDispute>): Promise<OrderDispute> => {
  return axios
    .post('order_disputes', form)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const updateDispute = async (
  id: string,
  form: Partial<OrderDispute>,
): Promise<OrderDispute> => {
  return axios
    .patch(`order_disputes/${getId(id)}`, form)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getOrderStatuses = async (): Promise<OrderStatus[]> => {
  const params = qs.stringify(
    {
      ...UNLIMITED_PAGINATION_PARAMS,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`new/order_statuses?${params}`, {
      headers: {
        Accept: 'application/ld+json',
      },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const getOrderCustomData = async (id: string): Promise<OrderCustomData> => {
  return axios
    .get(`${Resources.Orders}/${id}/order_custom_data`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const getOrderAdjustments = async (id: string): Promise<OrderAdjustments[]> => {
  return axios
    .get(`${Resources.Orders}/${id}/${Resources.OrderAdjustments}`, {
      headers: {
        Accept: 'application/ld+json',
      },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.message));
};
